export const LAYOUT_NAME = {
	DEFAULT: 'default', // default layout
	LATAM: 'latam', // latam layout
	US: 'US', // us layout
};